function truncateDecimals(number) {
    if (isNaN(number)) {
        number = 0;
    }
    return number.toFixed(2);
}

// Custom currency filter for Woolworths
module.exports = function (currencyFilter) {
    return function (amount, symbol) {
        const truncatedAmount = truncateDecimals(amount);
        if (symbol === undefined) {
            symbol = '$';
        }

        // 0 precision when the amount is less than 1 cent, otherwise 2 decimal places.
        return currencyFilter(truncatedAmount, '<sup>' + symbol + '</sup>', truncatedAmount < 0.01 ? 0 : 2);
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-currency.js
 **/